<template>
  <div>
    <h1 class="page-header">{{ $t('event.event') }}</h1>
    <div class="row">
      <div
        class="col-12 col-md-12 col-lg-4 col-xl-3 mb-3 mb-lg-0"
        v-show="isStaff"
      >
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div
        :class="isStaff ? 'col-12 col-md-12 col-lg-8 col-xl-9' : 'col-12'"
      >
        <ts-card>
          <ts-card-wrapper>
            <div class="d-flex flex-wrap justify-content-between align-items-center">
              <div class="mb-2 mb-sm-0"></div>
              <div
                class="d-flex align-items-center w-100 w-sm-auto justify-content-end flex-grow-1 flex-sm-grow-0 event-toolbar"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  class="event-search-input flex-grow-1 flex-sm-grow-0"
                />
                <ts-button
                  v-show="isStaff"
                  outline
                  class="ml-2 flex-shrink-0"
                  v-tooltip="$t('filter')"
                  @click.prevent="visible = true"
                >
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto table-responsive">
            <ts-loading-banner :loading="exporting">
              <Table
                :columns="columns"
                :data="groupResources"
                :loading="loading"
                :max-height="tableHeight"
                :span-method="handleSpan"
                row-key="index"
                @on-sort-change="handleSortChange"
                stripe
                highlight-row
                size="small"
              >
                <template slot-scope="{ row }" slot="event_name">
                  {{ $store.getters.limitStringShow(row.event_name) }}
                </template>
                <template slot-scope="{ row }" slot="event_criteria">
                  {{ $store.getters.limitStringShow(row.event_criteria) }}
                </template>
                <template slot-scope="{ row }" slot="is_staff_event">
                  <span
                    v-if="row.is_staff_event == true"
                    style="text-align: center;"
                    >{{ $t('yes') }}</span
                  >
                  <span v-else style="text-align: center;">{{ $t('no') }}</span>
                </template>
                <template slot-scope="{ row }" slot="is_parent_event">
                  <span
                    v-if="row.is_parent_event == true"
                    style="text-align: center;"
                    >{{ $t('yes') }}</span
                  >
                  <span v-else style="text-align: center;">{{ $t('no') }}</span>
                </template>
                <template slot-scope="{ row }" slot="is_student_event">
                  <span
                    v-if="row.is_student_event == true"
                    style="text-align: center;"
                    >{{ $t('yes') }}</span
                  >
                  <span v-else style="text-align: center;">{{ $t('no') }}</span>
                </template>
                <template slot-scope="{ row }" slot="status">
                  <span
                    v-if="row.event_id && (row.status === 'expired' || row.is_expired)"
                    class="badge badge-secondary"
                  >
                    {{ $t('pickupCardCreation.expired') || 'Expired' }}
                  </span>
                  <span
                    v-else-if="row.event_id"
                    class="badge badge-success"
                  >
                    {{ $t('active') || 'Active' }}
                  </span>
                </template>
                <template slot-scope="{ row }" slot="created_by">
                  {{ row.created_by && row.created_by.employee ? row.created_by.employee.name_en : '' }}
                </template>
                <template slot-scope="{ row }" slot="action">
                  <a
                    v-show="isStaff && !row.is_deleted"
                    href="#"
                    v-tooltip="$t('edit')"
                    class="text-primary mr-2"
                    @click.prevent="edit(row)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    v-show="isStaff && !row.is_deleted"
                    href="#"
                    v-tooltip="$t('delete')"
                    class="text-danger"
                    @click.prevent="destroy(row)"
                  >
                    <i class="fas fa-spin fa-spinner" v-if="row._deleting"></i>
                    <i class="fas fa-trash" v-else></i>
                  </a>
                </template>
              </Table>
            </ts-loading-banner>
          </div>
          <div class="d-flex justify-content-between align-items-center p-15 flex-wrap">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
      <a-drawer
        :title="$t('filter')"
        placement="right"
        :closable="true"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        :width="drawerWidth"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <ts-branch-filter @filter="value => (branch_id = value)" />
            </div>

            <!-- Active Status -->
            <div class="form-group">
              <label>{{ $t('status') || 'Status' }}</label>
              <a-select
                v-model="active_status"
                style="width: 100%"
              >
                <a-select-option value="active">{{ $t('active') || 'Active' }}</a-select-option>
                <a-select-option value="expired">{{ $t('pickupCardCreation.expired') || 'Expired' }}</a-select-option>
                <a-select-option value="all">{{ $t('all') || 'All' }}</a-select-option>
              </a-select>
            </div>

            <!-- Receivers -->
            <div class="form-group">
              <label>{{ $t('event.receivers') }}</label>
              <a-select
                v-model="receivers"
                mode="multiple"
                allowClear
                style="width: 100%"
                :placeholder="$t('event.receivers')"
              >
                <a-select-option value="staff">{{
                  $t('event.staff')
                }}</a-select-option>
                <a-select-option value="parent">{{
                  $t('event.parent')
                }}</a-select-option>
                <a-select-option value="student">{{
                  $t('event.student')
                }}</a-select-option>
              </a-select>
            </div>

            <!-- Date range -->
            <div class="form-group">
              <label>{{ $t('event.dateRange') }}</label>
              <a-range-picker
                v-model="date_range"
                style="width: 100%"
                format="YYYY-MM-DD"
              />
            </div>

            <!-- Is deleted -->
            <div class="form-group">
              <label>{{ $t('event.isDeleted') }}</label>
              <a-select
                v-model="is_deleted"
                allowClear
                style="width: 100%"
                :placeholder="$t('event.isDeleted')"
              >
                <a-select-option value="yes">{{ $t('yes') }}</a-select-option>
                <a-select-option value="no">{{ $t('no') }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
      </a-drawer>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
import iTable from '@/store/i-table-helper'

export default {
  components: {
    FormCreate
  },
  name: 'event',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      exporting: false,
      branch_id: [],
      receivers: [],
      date_range: [],
      is_deleted: 'no',
      active_status: 'active',
      visible: false,
      sort_by: 'event_name',
      sort_order: 'asc',
      tableHeight: 650,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1200
    }
  },
  created() {
    if (this.isParent) {
      this.branch_id = []
      this.branch_id.push(this.$store.state.selectedStudent.branch_id)
    } else {
      this.fetchData()
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapState('event', ['resources', 'pagination']),
    groupResources() {
      const grouped = iTable.rowGroup(this.resources, 'branch.branch_name_en')
      if (this.sort_by === 'event_name') {
        grouped.forEach(group => {
          if (group.children && Array.isArray(group.children)) {
            group.children.sort((a, b) => {
              const nameA = (a.event_name || '').toLowerCase()
              const nameB = (b.event_name || '').toLowerCase()
              return this.sort_order === 'desc'
                ? nameB.localeCompare(nameA)
                : nameA.localeCompare(nameB)
            })
          }
        })
      }
      return grouped
    },
    search: {
      get() {
        return this.$store.state.event.search
      },
      set(newVal) {
        this.$store.commit('event/SET_SEARCH', newVal)
        this.$store.commit('event/RESET_CURRENT_PAGE')
      }
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isParent() {
      return this.$store.getters.isParentLogin
    },
    selectedStudent() {
      return this.$store.state.selectedStudent.student_id
    },
    from_date() {
      return this.date_range && this.date_range[0]
        ? this.date_range[0].format('YYYY-MM-DD')
        : undefined
    },
    to_date() {
      return this.date_range && this.date_range[1]
        ? this.date_range[1].format('YYYY-MM-DD')
        : undefined
    },
    filters() {
      return {
        branch_id: this.branch_id,
        receivers: this.receivers,
        from_date: this.from_date,
        to_date: this.to_date,
        is_deleted: this.is_deleted,
        sort_by: this.sort_by,
        sort_order: this.sort_order,
        active_status: this.active_status,
        all_branch: Array.isArray(this.branch_id)
          ? this.branch_id.length
            ? undefined
            : true
          : true
      }
    },
    drawerWidth() {
      return this.windowWidth < 576 ? '85%' : '320px'
    },
    isMobile() {
      return this.windowWidth < 768
    },
    columns() {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15,
          className: 'text-primary bold'
        },
        {
          title: this.$t('event.name'),
          key: 'event_name',
          slot: 'event_name',
          minWidth: 180,
          ellipsis: true,
          tooltip: true,
          sortable: 'custom',
          sortType: this.sort_by === 'event_name' ? this.sort_order : 'normal'
        },

        {
          title: this.$t('event.startdate'),
          key: 'event_start_date',
          minWidth: 120,
          align: 'center',
          sortable: 'custom',
          sortType: this.sort_by === 'event_start_date' ? this.sort_order : 'normal'
        },
        {
          title: this.$t('event.enddate'),
          key: 'event_end_date',
          minWidth: 120,
          align: 'center',
          sortable: 'custom',
          sortType: this.sort_by === 'event_end_date' ? this.sort_order : 'normal'
        },
        {
          title: this.$t('status') || 'Status',
          slot: 'status',
          minWidth: 90,
          align: 'center'
        },
        {
          title: this.$t('event.criteria'),
          slot: 'event_criteria',
          minWidth: 130,
          ellipsis: true,
          tooltip: true
        },
        {
          title: this.$t('event.staff'),
          slot: 'is_staff_event',
          minWidth: 80,
          align: 'center'
        },
        {
          title: this.$t('event.parent'),
          slot: 'is_parent_event',
          minWidth: 80,
          align: 'center'
        },
        {
          title: this.$t('event.student'),
          slot: 'is_student_event',
          minWidth: 85,
          align: 'center'
        },
        {
          title: this.$t('created_by') || 'Created By',
          slot: 'created_by',
          minWidth: 120,
          ellipsis: true,
          tooltip: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: this.isMobile ? false : 'right',
          align: 'center',
          width: 90
        }
      ]
    }
  },
  methods: {
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    },
    handleSortChange({ key, order }) {
      if (order === 'normal') {
        this.sort_by = 'event_name'
        this.sort_order = 'asc'
      } else {
        this.sort_by = key || 'event_name'
        this.sort_order = order
      }
      this.$store.commit('event/RESET_CURRENT_PAGE')
      this.fetchData()
    },
    handleResize() {
      if (typeof window !== 'undefined') {
        this.windowWidth = window.innerWidth
        const availableHeight = window.innerHeight - 320
        this.tableHeight = Math.max(380, Math.min(availableHeight, 800))
      }
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'event/fetch',
          Object.assign({}, this.filters, { ...attributes })
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/events/${data.event_id}`)
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('event/delete', record.event_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    filters: {
      deep: true,
      handler: debounce(function() {
        this.$store.commit('event/RESET_CURRENT_PAGE')
        this.fetchData()
      }, 500)
    },
    selectedStudent: debounce(function() {
      if (this.isParent) {
        this.branch_id = []
        this.branch_id.push(this.$store.state.selectedStudent.branch_id)
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'event-create') {
      this.$store.commit('event/RESET_STATE')
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>

<style scoped>
.event-toolbar {
  width: 100%;
}
@media (min-width: 576px) {
  .event-toolbar {
    width: auto;
  }
}
.event-search-input {
  width: 100%;
  max-width: 300px;
}
@media (max-width: 575.98px) {
  .event-search-input {
    max-width: 100%;
  }
}

/* Prevent table header text from wrapping / breaking down into multiple lines */
::v-deep .ivu-table-header th .ivu-table-cell {
  white-space: nowrap !important;
  word-break: keep-all !important;
  text-overflow: ellipsis;
  padding-left: 8px !important;
  padding-right: 8px !important;
}

::v-deep .ivu-table-body td .ivu-table-cell {
  white-space: nowrap !important;
  word-break: keep-all !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
</style>
